module.exports = __webpack_public_path__ + "PTMETTAlogo-2.1680dbf8.png";